import { environment } from './../../../../environment/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from './../../../core/models/response-api';
import Pusher from 'pusher-js';
import { Subject } from 'rxjs';
import { CrudService } from '../crud-service/crud.service';
import { LocalStorageService } from '../local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService extends CrudService<ApiResponse<any>, number> {
  pusher: any;
  channel: any;
  messages$ = new Subject<any>();
  currentUser:any
  id:any

  constructor(_http: HttpClient,
    private localStorageService: LocalStorageService,

  ) {
    super(_http, `${environment.baseUrl}/api`);
    this.currentUser = this.localStorageService.getData('UserInfo');
    if (this.currentUser) {
      try {
        this.id = JSON.parse(this.currentUser).id;
      } catch (error) {
        console.error("Erreur lors du parsing de currentUser :", error);
      }
    } else {
      console.warn("currentUser est vide ou non défini.");
    }
    this.pusher = new Pusher('eb5150b9b1988b68581b', {
      cluster: 'mt1',
      disableStats: true,
    });
    console.log(this.id,"id in event notification")
    this.channel = this.pusher.subscribe('notifications.' + this.id);

    this.channel.bind('App\\Events\\NotificationEvent', (data: any) => {
      console.log('data', data);
      this.messages$.next(data);
    });
  }

  getChannel(channelName: string) {
    return this.pusher.subscribe(channelName);
  }
  getListOfNotification(id: any,per_page?:any,page?:any) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/Notification/notifications?per_page=${per_page}&page=${page}`
    );
  }


  disconnectt() {
    console.log('je suis laaaa')
    return this._http.post<ApiResponse<any>>(
     `https://api.wegestu.com/api/auth/logout`, {});
  }
  readNotification(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/Notification/markNotificationAsRead`,
      data
    );
  }
  getListOfNotificationNotRead(){
 
    return this._http.get<ApiResponse<any>>(this._base + `/Notification/notificationsNotRead`)
  }
  readNotificationall() {
    return this._http.post<ApiResponse<any>>(
      this._base + `/Notification/markNotificationAsRead?makeAllAsRead=1`, {});
  }
}
